module.exports = __webpack_public_path__ + "img/estilo-de-comunicacion.c155220b.png";